import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CalendarioService, Mes, Periodo} from '../../services/calendario.service';
import {Observable} from 'rxjs';
import {inOutList} from '../../util/animations/animations';
import {Platform} from '@ionic/angular';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.scss'],
  animations: [inOutList]
})
export class CalendarioComponent implements OnInit {
  meses$: Observable<Mes[]>;
  periodo: Periodo;
  @Input() width: number = 0;
  @Output() change: EventEmitter<Periodo> = new EventEmitter<Periodo>();

  constructor(private calendarioService: CalendarioService,
              private platform: Platform) {
  }

  ngOnInit() {
    this.meses$ = this.calendarioService.getMeses();
    this.calendarioService.getPeriodo().subscribe(periodo => {
        this.periodo = periodo;
        this.change.emit(periodo);
      }
    );
    if (this.width > 0 && this.platform.is('desktop')) {
      this.calendarioService.setPagination(this.width);
    }
  }

  selecionar(dia: any) {
    this.calendarioService.selecionar(dia);
  }

  voltarMes() {
    this.calendarioService.voltarMes();
  }

  avancarMes() {
    this.calendarioService.avancarMes();
  }

  voltarDia(isEnd: boolean = false) {
    this.calendarioService.voltarDia(isEnd);
  }

  avancarDia(isEnd: boolean = false) {
    this.calendarioService.avancarDia(isEnd);
  }

  resetar() {
    this.calendarioService.resetar();
  }

}
